import React, { useState, useEffect, useContext } from 'react';
import { GlobalContext } from '../../../Context/GlobalContext';
import { Elements } from '@stripe/react-stripe-js';
import CheckoutForm from './CheckoutForm.js';
import axios from 'axios';
import './StripeCheckout.css'

// creates a payment intent in stripe that returns the a clientSecret
const ExpressPay = ({ 
  stripePromise,
  companyEndpoint,
  connectedStripeId,
  videoId,  
  viewerId, 
  item
}) =>{
  const [clientSecret, setClientSecret] = useState(null);
  const API_URL = " https://do2v45e3qi.execute-api.us-west-2.amazonaws.com/production";
  const { viewerObj } = useContext(GlobalContext)

  useEffect(() => { 
  
    //don't start payment intent until stripePromise has loaded
    if(!stripePromise) return;
      // return the client secret of customer checking out
      (async() => {
        const { data } = await axios.post(`${API_URL}/create-payment-intent`,{
          item,
          videoId,
          viewerEmail: viewerObj.email,
          connectedStripeId,
        });
        const { clientSecret } = data;
        
        setClientSecret(clientSecret);
      })();

  }, [stripePromise, item]);


  return (
    <div className="App">
      {clientSecret && stripePromise && (
        //stripe promise is needed to render the stripe components
        <Elements  stripe={stripePromise}> 
          <CheckoutForm 
            clientSecret={clientSecret}
            companyEndpoint={companyEndpoint}
            videoId={videoId} 
            viewerId={viewerId} 
            item={item}/>
        </Elements>
      )}

      {/* If no clientSecret or stripePromise show loading animation */}
      {!clientSecret && !stripePromise &&(
      <div className="checkout-form">
        Card Details
        <div className="payment-input-skeleton"></div>
        <button className='pay-now' id="submit" disabled={true}>
          <span id="button-text" >Pay now</span>
        </button>
      </div>
    )}
    </div>
  );
};

export default ExpressPay;
